import { Injectable } from '@angular/core';
import { BaseHelperUrl } from './base.helper.url';
import {ApiUrls} from './api.urls';

@Injectable()
export class RequestHelperUrl {
  private readonly baseUrl;
  private readonly urls;

  constructor(private baseHelperUrl: BaseHelperUrl) {
    this.baseUrl = this.baseHelperUrl.getUrl();
    this.urls = ApiUrls.GetApiUrl();
  }

  getUrl(key) {
    const splitKey = key.split('.');
    if (splitKey.length > 1) {
      let temp = null;
      let tempPath = '';
      let path = '';

      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < splitKey.length; i++) {
        if (typeof temp === 'object' && temp !== null ) {
          temp = temp[splitKey[i]];
          tempPath = splitKey[i];
          if (i !== (splitKey.length - 1)) {
            tempPath += '/';
          }
        }
        if (typeof temp === 'string') {
          tempPath = temp;
        }
        if (temp === null) {
          temp = this.urls[splitKey[i]];
          tempPath = splitKey[i] + '/';
        }
        path += tempPath;
      }
      return this.baseUrl + path;
    }
    return this.baseUrl + this.urls[key];
  }

  getBaseUrl() {
    return this.baseHelperUrl.getBaseUrl();
  }
}
